<template>
  <div>
    <div class="row q-col-gutter-md q-mb-md">
      <div class="col-12">
        <q-item-label>Image</q-item-label>
        <div class="hero-container">
          <div
            v-if="showGrid && section.config.heroImage"
            class="position-grid"
            :style="`left: ` + section.config.heroImagePosition.x + `%;` + `border-left: 2px solid white;`"
          />
          <div
            v-if="showGrid && section.config.heroImage"
            class="position-grid"
            :style="`top: ` + section.config.heroImagePosition.y + `%;` + `border-top: 2px solid white;`"
          />
          <image-uploader
            v-model="section.config.heroImage"
            :image-url="section.heroImageUrl"
            :model="section"
          />
        </div>
      </div>
    </div>

    <div class="row q-col-gutter-md q-mb-md">
      <div class="col-3">
        <q-input
          v-model.number="section.config.heroImageHeight"
          type="number"
          label="Image Height"
          min="0"
          clearable
          :rules="[val => val >= 0 || 'Please enter a number greater than 0']"
          bottom-slots
        />
      </div>
      <div class="col-3">
        <q-item-label>Horizontal Resize Position</q-item-label>
        <q-slider
          v-model.number="section.config.heroImagePosition.x"
          label
          type="number"
          :min="0"
          :max="100"
          :style="positionControlsDisabled ? `pointer-events: none;` : ``"
          :disabled="positionControlsDisabled"
        />
        <q-tooltip v-if="positionControlsDisabled">
          Give the image a fixed height control the background position.
        </q-tooltip>
      </div>
      <div class="col-3">
        <q-item-label>Vertical Resize Position</q-item-label>
        <q-slider
          v-model.number="section.config.heroImagePosition.y"
          label
          type="number"
          :min="0"
          :max="100"
          :style="positionControlsDisabled ? `pointer-events: none;` : ``"
          :disabled="positionControlsDisabled"
        />
        <q-tooltip v-if="positionControlsDisabled">
          Give the image a fixed height control the background position.
        </q-tooltip>
      </div>
      <div class="col-3">
        <q-toggle
          v-model="showGrid"
          label="Gridlines"
        />
      </div>
    </div>

    <div class="row q-col-gutter-md q-mb-md">
      <div class="col-6">
        <q-select
          v-model="section.config.heroImageActionType"
          label="Action Type"
          :options="section.config.heroImageActionOptions"
          clearable
          bottom-slots
          map-options
          emit-value
        />
      </div>
      <div class="col-6">
        <q-select
          v-if="section.config.heroImageActionType === 'Movie'"
          v-model="section.config.heroImageAction['Movie']"
          label="Movie"
          clearable
          input-debounce="100"
          :options="moviesOptions"
          input-style="search"
          stack-label
          :use-input="true"
          bottom-slots
          map-options
          emit-value
          @filter="filterMovies"
        />
        <q-select
          v-else-if="section.config.heroImageActionType === 'Page'"
          v-model="section.config.heroImageAction['Page']"
          label="Page"
          :options="pagesOptions"
          clearable
          bottom-slots
          map-options
          emit-value
        />
        <q-input
          v-else-if="section.config.heroImageActionType === 'URL'"
          v-model="section.config.heroImageAction['URL']"
          class="col-3"
          label="URL"
          :rules="[val => $_.startsWith(val, 'http') || 'Please enter a valid url']"
          bottom-slots
        />
      </div>
    </div>
  </div>
</template>

<script>

import Section from 'src/models/page/Section'
import ImageUploader from 'src/modules/admin/components/ImageUploader'

export default {
  name: 'HeroImageEditor',
  components: {
    ImageUploader
  },
  props: {
    section: {
      type: Section,
      required: true
    }
  },
  data () {
    return {
      movieSearchString: '',
      showGrid: true
    }
  },
  computed: {
    moviesOptions () {
      return this.movies.data.map(movie => ({
        label: movie.name,
        value: {
          id: movie.id,
          name: movie.name
        }
      }))
    },
    pagesOptions () {
      return this.pages.data.map(page => ({
        label: page.title,
        value: page.slug
      }))
    },
    positionControlsDisabled () {
      return !this.section.config.heroImageHeight || this.section.config.heroImageHeight === ''
    }
  },
  watch: {
    'section.config.heroImage' () {
      if (!this.section.config.heroImage) {
        this.section.config.heroImageHeight = null
        this.section.config.heroImagePosition = {
          x: 50,
          y: 50
        }
      }
    }
  },
  methods: {
    filterMovies (val, update, abort) {
      update(() => {
        this.movieSearchString = val
      })
    }
  },
  models: {
    movies: {
      variables () {
        const movie = this.section.config.heroImageAction.Movie
        return {
          searchString: movie?.name || this.movieSearchString,
          orderBy: 'createdAt',
          descending: true,
          limit: 5
        }
      }
    },
    pages: {
      fields: ['slug', 'title'],
      variables: {
        limit: 100
      }
    }
  }
}

</script>

<style scoped>
.hero-container {
  position: relative;
}

.position-grid {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}

</style>
